define('score_bootstrap/Components/ContentSearch/QuickView',[ "jquery"], function ($) {

    function QuickView(scope) {
        var $scope = $("li", scope).remove();

        this.index = -1;

        Object.defineProperties(this, {
            $scope: { enumerable: false, value: $scope },
            $body: { enumerable: false, value: $(".quick-view-body", $scope) },
            $prevBtn: { enumerable: false, value: $(".controls-back", $scope) },
            $nextBtn: { enumerable: false, value: $(".controls-forward", $scope) }
        });

        // Clicking on "Quick View" link inserts quick view element into search results grid and loads quick view tile html
        //$(this.scope).on("click", ".quick-view-link", function (event) {
        //    event.preventDefault();
        //    event.stopPropagation();
        //    $(".bj-product-quick-view").removeClass("search-loaded");
        //
        //    var $anchor = $(event.target), $li = $anchor.closest("li"), url = $anchor.attr("href");
        //
        //    this.quickView.$scope.remove();
        //    toggleQuickViewButtons($li.index(), this.tiles.length, this.quickView.$prevBtn, this.quickView.$nextBtn);
        //    this.showQuickView($li);
        //    this.quickView.showTile($li, url);
        //}.bind(this))
        //.on("click", "." + quickViewClass + " .close", this.hideQuickView.bind(this))
        //.on("click", "." + quickViewClass + " .controls-back", function () {
        //    var newIndex = this.quickView.hideTile() - 1, $tile = $(this.tiles.get(newIndex));
        //
        //    // If a promo tile is in the prev position or if prev tile does not have quick
        //    // view link then we need to skip over it.
        //    while ($tile.length && ($tile.hasClass(promoClass) || $tile.find(quickViewLinkClass).length === 0)) {
        //        $tile = $tile.prev();
        //    }
        //
        //    this.quickView.$scope.remove();
        //
        //    // make sure we didn't reach the end of the grid
        //    if ($tile.length === 0) {
        //        return;
        //    }
        //
        //    toggleQuickViewButtons($tile.index(), this.tiles.length, this.quickView.$prevBtn, this.quickView.$nextBtn);
        //    this.showQuickView($tile);
        //    this.quickView.showTile($tile);
        //}.bind(this))
        //.on("click", "." + quickViewClass + " .controls-forward", function () {
        //    var newIndex = this.quickView.hideTile() + 1, tile = this.tiles.get(newIndex), $tile = $(tile);
        //
        //    // If next index if pointing at quick view then we reached the end of the row and we need to skip over it.
        //    // If a promo tile is in the next position then we also need to skip over it.
        //    // If tile does not have Quick View link then we also need to skip over it
        //    while ($tile.length && ($tile.hasClass(quickViewClass) || $tile.hasClass(promoClass) || $tile.find(quickViewLinkClass).length === 0)) {
        //        $tile = $tile.next();
        //    }
        //
        //    this.quickView.$scope.remove();
        //
        //    // make sure we didn't reach the end of the grid
        //    if (!$tile.length) {
        //        return;
        //    }
        //
        //    toggleQuickViewButtons($tile.index(), this.tiles.length, this.quickView.$prevBtn, this.quickView.$nextBtn);
        //    this.showQuickView($tile);
        //    this.quickView.showTile($tile);
        //}.bind(this));
    }

    function scrollIntoView(target) {
        var rect = target.getBoundingClientRect();
        if (rect.bottom > window.innerHeight) {
            target.scrollIntoView(false);
        }

        if (rect.top < 0) {
            target.scrollIntoView();
        }
    }

    QuickView.prototype.toggleControls = function toggleControls(activeIndex, totalTiles) {
        this.$prevBtn.css("display", activeIndex <= 0 ? "none" : "inline-block");
        this.$nextBtn.css("display", activeIndex >= (totalTiles - 1) ? "none" : "inline-block");
    };

    QuickView.prototype.setTile = function setTile(tile) {
        this.$body.html(tile ? tile.tileHtml : "");
    };

    QuickView.prototype.show = function show(tile, index) {
        this.setTile(tile);
        this.$scope.show();
        this.index = index;
        scrollIntoView(this.$scope[0]);
    };

    QuickView.prototype.hide = function hide() {
        this.$scope.remove();
        this.index = -1;
        this.setTile(null);
    };

    QuickView.init = function initQuickView(args) {
        return new QuickView(args.scope);
    };

    return QuickView;
});
